<div class="planning-postpone">
  <button
    type="button"
    class="btn btn-sm btn-outline-primary"
    [disabled]="disabled"
    (click)="togglePanel()">
    Change
  </button>

  @if (isPanelOpen) {
    <div class="planning-postpone-panel mt-3">
      <textarea-field
        label="Postponed reason"
        placeholder="Briefly explain the reason to change due date"
        [height]="120"
        [textareaFormControl]="postponedReasonControl">
      </textarea-field>

      <div class="d-flex justify-content-end gap-2 mt-2">
        <button type="button" class="btn btn-sm btn-secondary" (click)="closePanel()">Cancel</button>
        <button type="button" class="btn btn-sm btn-primary" (click)="save()">Save</button>
      </div>
    </div>
  }
</div>
